import { Link } from 'react-router-dom'

const Hero = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section className="hero hero-bg-circles" id="home">
      <div className="container">
        <div className="hero-content">
          <h2 className="hero-title">未来へ、次の挑戦へ。</h2>
          <p className="hero-description">
          一般社団法人 日本ITビジネス・プロフェッショナル協会は、ITとビジネスをつなぐプロフェッショナル人材が、安心して力を発揮できる環境を整え、若手からベテランまで幅広い世代の活躍を支援します。
          </p>
          <p className="hero-description">
          知識と経験を基盤に常にスキルを磨き、顧客の成功を支えるとともに、日本社会全体のDX/AXを推進し、未来の発展に貢献していきます。
          </p>
          <div className="hero-buttons">
            <a
              href="#about"
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('about')
              }}
            >
              詳しく見る
            </a>
            <Link to="/contact" className="btn btn-secondary">
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
